import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getHrUsersList, deleteHrUserById } from "../../api/hrUserApi";
import { useParams } from "react-router";
import { deleteNotification } from "../../utils/useNotification";
import styled from "styled-components";
import {
  Avatar,
  Badge,
  Flex,
  Input,
  Pagination,
  Popover,
  Table,
} from "@mantine/core";
import TableEditButton from "../common/TableEditButton";
import TableDeleteButton from "../common/TableDeleteButton";
import AreYouSureModal from "../common/AreYouSureModal";

function PanelUserTable() {
  const navigate = useNavigate();

  const [tableData, setTableData] = useState<any>();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  //for delete modal
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  //for sort
  const [sort, setSort] = useState<any>("");
  //for search
  const [searchedName, setSearchedName] = useState<any>();
  const { id } = useParams(); 

  const getTableData = async () => {
    try {
      const { data }: any = await getHrUsersList({
        pageNumber: page,
        limit: limit,
        companyId: id as string,
        sort,
        name: searchedName,
      });

      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
    } catch (error) {}
  };

  const handleDeleteClick = async (userId: any) => {
    try {
      const { data }: any = await deleteHrUserById({
        id: userId,
      });
      deleteNotification(data?.success);
      getTableData();
    } catch (error) {
      console.error("Error generating key:", error);
    }
  };
  useEffect(() => {
    if (page) {
      //navigate(`?page=${page}&limit=${limit}`, { replace: true });
      getTableData();
    }
  }, [page, sort, searchedName]);

  return (
    <TableWrapper>
      <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            style={{
              borderCollapse: "separate",
              borderSpacing: "0px 4px",
            }}
            verticalSpacing="sm"
            withRowBorders={false}
          >
            <Table.Thead>
              <Table.Tr>
                <StyledTableTh style={{ width: "30%" }}>
                  <Flex gap={4}>
                    <Flex
                      gap={4}
                      style={{
                        cursor: "pointer",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSort((prev: string) =>
                          prev === "desc" ? "asc" : "desc"
                        );
                      }}
                    >
                      <div>Ad Soyad</div>
                      {sort === "desc" ? (
                        <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                      ) : (
                        <Avatar src={"/assets/descSortIcon.png"} size={16} />
                      )}
                    </Flex>
                    <Popover position="right" shadow="md">
                      <Popover.Target>
                        <div style={{ width: "max-content" }}>
                          <Avatar
                            style={{
                              cursor: "pointer",
                            }}
                            src={"/assets/searchIcon.png"}
                            size={16}
                          />
                        </div>
                      </Popover.Target>
                      <Popover.Dropdown>
                        <Input
                          value={searchedName}
                          onChange={(event) => {
                            {
                              setPage(1);
                              setSearchedName(event.currentTarget.value);
                            }
                          }}
                        />
                      </Popover.Dropdown>
                    </Popover>
                  </Flex>
                </StyledTableTh>
                <StyledTableTh style={{ width: "25%" }}>Telefon</StyledTableTh>
                <StyledTableTh style={{ width: "20%" }}>Yetki</StyledTableTh>
                <StyledTableTh style={{ width: "10%" }}>
                  <button
                    onClick={() => navigate(`/companies/detail/${id}/panel-users/new`)} 
                    style={{
                      backgroundColor: "#5C26FF",
                      color: "white",
                      padding: "6px 12px",
                      borderRadius: "8px",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    + Yeni Ekle
                  </button>
                </StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody style={{ backgroundColor: "#FBFBFB" }}>
              {tableData?.map((hrUser: any) => (
                <Table.Tr
                  style={{
                    color: "#1D1B20",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                  bg={"#F9F9F9"}
                  key={hrUser._id}
                >
                  <Table.Td style={{ width: "30%" }}>
                    <Flex justify={"start"} align={"center"} gap={16}>
                      <Badge
                        style={{ cursor: "pointer" }}
                        circle
                        bg={"#EADDFF"}
                        size={"40px"}
                      >
                        <AvatarText>{hrUser.name[0]}</AvatarText>
                      </Badge>
                      {hrUser.name}
                    </Flex>
                  </Table.Td>
                  <Table.Td style={{ width: "25%" }}>{hrUser.phone}</Table.Td>
                  <Table.Td style={{ width: "20%" }}>
                    {hrUser.privilege}
                  </Table.Td>
                  <Table.Td style={{ width: "10%" }}>
                    <Flex gap={12}>
                      <TableEditButton
                        onClick={() => {
                          navigate(`/companies/detail/${id}/panel-users/edit/${hrUser._id}`)
                        }}
                      />
                      <TableDeleteButton
                        onClick={() => {
                          setitemToDeleteId(hrUser?._id);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </div>

        <Flex justify="center" mt="md" pb="sm">
          <Pagination
            total={totalPages}
            value={page}
            onChange={setPage}
            withEdges
            color="#5C26FF"
            radius="xl"
          />
        </Flex>

      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Panel Kullanıcısı Sil"
        text="Bu panel kullanıcısını silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </TableWrapper>
  );
}

export default PanelUserTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const AvatarText = styled.div`
  color: #21005d;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  justify-content: space-between;
`;
